import { Translate } from "components/common/Translate/Translate";
import { ContentItem } from "../ContentItem/ContentItem";
import { ContentParent } from "../ContentParent";
import { LightningFastIcon } from "components/common/Icons/LightningFastIcon";
import { ImageFormatsIcon } from "components/common/Icons/ImageFormatsIcon";
import { PaintIcon } from "components/common/Icons/PaintIcon";
import { PrivacyGuaranteedIcon } from "components/common/Icons/PrivacyGuaranteedIcon";
import { HeartIcon } from "components/common/Icons/HeartIcon";

export const ColorPickerContent = () => {
    return (
        <ContentParent>
            <ContentItem
                title={<Translate keyName="content-easy-title" />}
                description={<Translate keyName="content-easy-sub-title" />}
                icon={<LightningFastIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-formats-title" />}
                description={<Translate keyName="content-formats-sub-title" />}
                icon={<ImageFormatsIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-palettes-title" />}
                description={<Translate keyName="content-palettes-sub-title" />}
                icon={<PaintIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-privacy-title" />}
                description={<Translate keyName="content-privacy-sub-title" />}
                icon={<PrivacyGuaranteedIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-online-title" />}
                description={<Translate keyName="content-online-sub-title" />}
                icon={<PrivacyGuaranteedIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-free-title" />}
                description={<Translate keyName="content-free-sub-title" />}
                icon={<HeartIcon />}
            />
        </ContentParent>
    );
};
